import { render, staticRenderFns } from "./FriendToggleVisible.vue?vue&type=template&id=0ccbbff8&"
import script from "./FriendToggleVisible.vue?vue&type=script&lang=js&"
export * from "./FriendToggleVisible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports